var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled, useTheme } from '../theme-provider';
import { useRefState } from '../helpers/hooks/use-ref-state';
import { getValueBubbleHeight, THUMB_SIZE, } from './thumb';
import { Thumbs } from './thumbs';
import { useElementRefBeforeFirstPaint } from '../helpers/hooks/use-element-ref-before-first-paint';
import { Marks } from './marks';
import { Rail } from './rail';
import { getCommonProps } from '../helpers/common-props';
const StyledSliderWrapper = styled.div.withConfig({ displayName: "StyledSliderWrapper", componentId: "sc-1whl339" }) `overflow:hidden;padding:calc(\n\t\t\t${THUMB_SIZE / 2}px +\n\t\t\t\t${(props) => props.hideValueBubbles
    ? props.theme.size.static100
    : getValueBubbleHeight(props.theme)}\n\t\t)${THUMB_SIZE}px 0;isolation:isolate;`;
export const MultiSlider = (props) => {
    var _a, _b;
    const language = useTheme().language;
    const defaultValueFormatter = React.useCallback((value) => value.toLocaleString(language, {
        maximumFractionDigits: 2,
    }), [language]);
    const { min, max, step, thumbs, backgroundGradient, fillStyle, onChange, onChangeImmediate, ariaDescribedBy, rigidThumbs, getValueText = defaultValueFormatter, appearance = 'default', highlights = [], hideValueBubbles = false, minRangeBetweenThumbs = 0, showIntervals = false, hideMinMax, } = props;
    const commonProps = getCommonProps(props);
    const railElementRef = React.useRef(null);
    useElementRefBeforeFirstPaint(railElementRef);
    const defaultValues = thumbs.map((t) => t.defaultValue);
    const [stateValues, setStateValues, stateValuesRef] = useRefState(defaultValues);
    // set a plausible default for rough estimate calculation in SSR
    const railWidth = (_b = (_a = railElementRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 400;
    return (React.createElement(StyledSliderWrapper, Object.assign({ hideValueBubbles: hideValueBubbles }, commonProps),
        React.createElement(Rail, { railElementRef: railElementRef, backgroundGradient: backgroundGradient, fillStyle: fillStyle, stateValues: stateValues, min: min, max: max, appearance: appearance, showIntervals: showIntervals, step: step },
            React.createElement(Thumbs, { minRangeBetweenThumbs: minRangeBetweenThumbs, thumbs: thumbs, min: min, max: max, rigidThumbs: rigidThumbs, onChange: onChange, onChangeImmediate: onChangeImmediate, step: step, getValueText: getValueText, highlights: highlights, hideValueBubbles: hideValueBubbles, ariaDescribedBy: ariaDescribedBy, railElementRef: railElementRef, appearance: appearance, stateValues: stateValues, setStateValues: setStateValues, stateValuesRef: stateValuesRef, defaultValues: defaultValues })),
        React.createElement(Marks, { getValueText: getValueText, highlights: highlights, railWidth: railWidth, min: min, max: max, hideMinMax: hideMinMax })));
};
export const Slider = (_a) => {
    var { defaultValue, onChange, onChangeImmediate, ariaLabel, ariaLabelledby } = _a, multiProps = __rest(_a, ["defaultValue", "onChange", "onChangeImmediate", "ariaLabel", "ariaLabelledby"]);
    const thumbs = React.useMemo(() => [
        {
            defaultValue,
            ariaLabel,
            ariaLabelledby,
        },
    ], [defaultValue, ariaLabel, ariaLabelledby]);
    const onChangeMulti = React.useCallback((values) => onChange === null || onChange === void 0 ? void 0 : onChange(values[0]), [onChange]);
    const onChangeImmediateMulti = React.useCallback((values) => onChangeImmediate === null || onChangeImmediate === void 0 ? void 0 : onChangeImmediate(values[0]), [onChangeImmediate]);
    return (React.createElement(MultiSlider, Object.assign({ thumbs: thumbs, onChange: onChangeMulti, onChangeImmediate: onChangeImmediateMulti }, multiProps)));
};
